<template>
    <div class="dummyWrap" :class=buttonStatusClass>
        <div class="dummyBox" v-on:click="displayBox">{{labelCheckBox}}</div>
    </div>
    <div id="departureTest" v-show="displayCheckBoxArea">
        <div id="label_wrap">
            <label v-for="(value, key) in departureItemList" :for="value.id" v-show="value.parentIdList[condition.selectedDeparturePref.value] || !condition.selectedDeparturePref.value">
                <input name='dept' :value="key" :id="value.id" type="checkbox" v-model="selectedDepartureList"><span>{{value.name}}</span>
            </label>
        </div>
        <div class="decision" v-on:click="hideAndSelect">決定</div>
    </div>
</template>

<script>
    import { ref, onMounted, watchEffect } from 'vue'
    export default ({
        props: {
            master : {type: Object, require: true},
            condition : {type: Object, require: true},
        },
        setup (props, context) {
            const displayCheckBoxArea = ref(false) //対象を表示するか
            const labelCheckBox = ref("-") // 最終選択したラベル
            const selectedDepartureList = ref(props.condition.selectedDeparture.value) // 選択されているチェックボックス
            const buttonStatusClass = ref("buttonStatusClass") // ドロップダウン自体の有効無効
            const departureItemList = JSON.parse(props.master.departureItemList)
            let defaultSelectedDepartureList = props.condition.selectedDeparture.value

            watchEffect(() => {
                context.emit("departure", selectedDepartureList);
            })

            // 監視の実装
            watchEffect(() => {
                // 下層ボタンの調整
                if (props.condition.selectedDeparturePref.value) {
                    buttonStatusClass.value = ""
                } else {
                    buttonStatusClass.value = "buttonStatusClass"
                }

                // 都道府県が変更だったら、チェックを全部外す。
                selectedDepartureList.value = defaultSelectedDepartureList
                labelCheckBox.value = "-"
                displayCheckBoxArea.value = false
            })

            // メソッド
            const hideAndSelect = () => {
                displayCheckBoxArea.value = false

                if (selectedDepartureList.value.length == 0) {
                    labelCheckBox.value = "-"
                    return;
                }

                // チェックされている値をせっていする。
                let displayStringList = []
                selectedDepartureList.value.forEach(function(selectedDepartureId){
                    let targetDeparture = departureItemList[selectedDepartureId]
                    displayStringList.push(targetDeparture.name)
                })
                
                labelCheckBox.value = displayStringList.join(",", displayStringList)
            };

            const displayBox = () => {
                displayCheckBoxArea.value = true
            };

            // 完了時
            onMounted(() => {
                defaultSelectedDepartureList = []
                hideAndSelect()
            })

            return {
                departureItemList,
                displayCheckBoxArea,
                labelCheckBox,
                selectedDepartureList,
                buttonStatusClass,
                hideAndSelect,
                displayBox,
            }
        },
        emits: ['departure']
    })
</script>